import GovernanceExceptionQueue from "@/components/governance/GovernanceExceptionQueue";

export default function PCExceptionQueue() {
  return (
    <GovernanceExceptionQueue
      title="PC Exception Queue"
      roleScope="pc"
      emptyCopy="No active PC coordination exceptions."
    />
  );
}
